import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActions = ({ selectedCount, onBulkStatusUpdate, onBulkExport, onBulkDelete, onClearSelection }) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedAction, setSelectedAction] = useState('');

  const bulkActions = [
    { value: 'status-ongoing', label: 'تغيير الحالة إلى جاري', icon: 'Play' },
    { value: 'status-completed', label: 'تغيير الحالة إلى مكتمل', icon: 'CheckCircle' },
    { value: 'status-planned', label: 'تغيير الحالة إلى مخطط', icon: 'Clock' },
    { value: 'export-excel', label: 'تصدير إلى Excel', icon: 'Download' },
    { value: 'export-pdf', label: 'تصدير إلى PDF', icon: 'FileText' },
    { value: 'delete', label: 'حذف المحدد', icon: 'Trash2', destructive: true }
  ];

  const handleActionExecute = () => {
    if (!selectedAction) return;

    switch (selectedAction) {
      case 'status-ongoing': onBulkStatusUpdate('ongoing');
        break;
      case 'status-completed':
        onBulkStatusUpdate('completed');
        break;
      case 'status-planned': onBulkStatusUpdate('planned');
        break;
      case 'export-excel':
        onBulkExport('excel');
        break;
      case 'export-pdf':
        onBulkExport('pdf');
        break;
      case 'delete':
        onBulkDelete();
        break;
    }

    setSelectedAction('');
    setIsExpanded(false);
  };

  if (selectedCount === 0) {
    return null;
  }

  return (
    <div className="fixed bottom-6 left-1/2 transform -translate-x-1/2 z-300">
      <div className="bg-card border border-border rounded-lg shadow-elevation-3 p-4 animate-slide-up">
        <div className="flex items-center space-x-4">
          {/* Selection Info */}
          <div className="flex items-center space-x-2">
            <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
              <span className="text-xs font-medium text-primary-foreground">
                {selectedCount}
              </span>
            </div>
            <span className="text-sm font-medium text-foreground">
              تم تحديد {selectedCount} مشروع
            </span>
          </div>

          {/* Quick Actions */}
          <div className="flex items-center space-x-2">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => onBulkStatusUpdate('ongoing')}
              iconName="Play"
              iconPosition="left"
              iconSize={14}
            >
              جاري
            </Button>

            <Button
              variant="ghost"
              size="sm"
              onClick={() => onBulkStatusUpdate('completed')}
              iconName="CheckCircle"
              iconPosition="left"
              iconSize={14}
            >
              مكتمل
            </Button>

            <Button
              variant="ghost"
              size="sm"
              onClick={() => onBulkExport('excel')}
              iconName="Download"
              iconPosition="left"
              iconSize={14}
            >
              تصدير
            </Button>
          </div>

          {/* More Actions Toggle */}
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setIsExpanded(!isExpanded)}
            iconName={isExpanded ? 'ChevronUp' : 'ChevronDown'}
            iconSize={16}
          >
            المزيد
          </Button>

          {/* Clear Selection */}
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
            iconName="X"
            iconSize={16}
            title="إلغاء التحديد"
          />
        </div>

        {/* Expanded Actions */}
        {isExpanded && (
          <div className="mt-4 pt-4 border-t border-border animate-slide-up">
            <div className="flex items-center space-x-3">
              <Select
                options={bulkActions?.map(action => ({
                  value: action?.value,
                  label: action?.label
                }))}
                value={selectedAction}
                onChange={setSelectedAction}
                placeholder="اختر إجراء..."
                className="flex-1"
              />

              <Button
                variant={bulkActions?.find(a => a?.value === selectedAction)?.destructive ? 'destructive' : 'default'}
                size="sm"
                onClick={handleActionExecute}
                disabled={!selectedAction}
                iconName="Play"
                iconPosition="left"
                iconSize={14}
              >
                تنفيذ
              </Button>
            </div>

            {/* Action Preview */}
            {selectedAction && (
              <div className="mt-3 p-3 bg-muted rounded-lg">
                <div className="flex items-center space-x-2">
                  <Icon 
                    name={bulkActions?.find(a => a?.value === selectedAction)?.icon || 'Info'} 
                    size={16} 
                    className="text-muted-foreground" 
                  />
                  <span className="text-sm text-foreground">
                    سيتم تطبيق "{bulkActions?.find(a => a?.value === selectedAction)?.label}" على {selectedCount} مشروع
                  </span>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default BulkActions;